<template>
  <div class="avoidance-status" :class="statusClass" v-if="status !== OrderAvoidanceStatus.NotAvoided">
    <div class="status-content">
      <img 
        v-if="statusIcon" 
        :src="statusIcon" 
        alt="status icon" 
        class="status-icon"
      />
      <span class="status-text">{{ statusText }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { OrderAvoidanceStatus } from '@/graphql/generated';
import PartiallyAvoidedIcon from '@/assets/img/pages/reconciliation/partially-avoided.svg';
import AvoidedIcon from '@/assets/img/pages/reconciliation/avoided.svg'; 

const props = defineProps<{
  status: OrderAvoidanceStatus;
}>();

const statusConfig = {
  [OrderAvoidanceStatus.NotAvoided]: {
    text: 'Не аннулировано',
    class: 'text-green',
    icon: null
  },
  [OrderAvoidanceStatus.PartiallyAvoided]: {
    text: 'Частично',
    class: 'text-blue',
    icon: PartiallyAvoidedIcon
  },
  [OrderAvoidanceStatus.Avoided]: {
    text: 'Полностью',
    class: 'text-red',
    icon: AvoidedIcon
  }
} as const;

const statusText = computed(() => statusConfig[props.status]?.text || String(props.status));
const statusClass = computed(() => statusConfig[props.status]?.class || '');
const statusIcon = computed(() => statusConfig[props.status]?.icon);
</script>

<style scoped lang="scss">
.avoidance-status {
  display: inline-block;
}

.status-content {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>